import i18n_en from 'src/shared/i18n/en.json';
import i18n_vi from 'src/shared/i18n/vi.json';

export const DEFAULT_PAGE = 0;
export const DEFAULT_PAGE_SIZE = 5;
export const DEFAULT_SORT_TYPE = 'DESC';
export const DEFAULT_SORT_PROPERTY = 'id';
export const NUMBER_PATTERN = '^[0-9]*[0-9,.]*[0-9]$';
export const NATURAL_NUMBER_PATTERN = '^[0-9]*$';
export const NATURAL_NUMBER_GREATER_THAN_ZERO_PATTERN = '^[1-9]+[0-9]*$';
export const NUMBER_DECIMAL = '^([-+0-9.]+)';
export const DATE_PATTERN = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;
export const EMAIL_PATTERN = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const CONVERSATION_REPLACE_PATTERN_1 = /[,.!;"?'’]/g;
export const CONVERSATION_REPLACE_PATTERN_2 = /[-]/g;
export const MAX_INTEGER_VALUE = 2147483647;
export const MIN_INTEGER_VALUE = -2147483647;
export const TZ_SERVER = 'UTC';
export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATETIME_FORMAT = 'DD/MM/YYYY HH:mm:ss';
export const DATETIME_MIN_FORMAT = 'DD/MM/YYYY HH:mm';
export const DATETIME_FORMAT_ISO = 'YYYY-MM-DDTHH:mm:ss.sssZZ';
export const HEX_VALUES = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e'];
export const DEFAULT_LANGUAGE = 'vi';
export const USER_CODE_PREFIX = 'K-'
export const PRIVATE_BUCKET = 'vietchaucontrol-private';
export const PUBLIC_BUCKET = 'vietchaucontrol-public';
export const PUBLIC_BUCKET_PREFIX = 'https://storage.googleapis.com/vietchaucontrol-public/';

export const I18nConfig = {
    en: i18n_en,
    vi: i18n_vi
};

export const ApiURI = {
    TODO: 'todos',
    OAUTH_TOKEN: '/oauth/token',

    GET_UPLOAD_SIGNED_URL: 'cloud/storage/getUploadSignedUrl',

    GET_LIST_CITY: '/guest/city/getListCity',
    UNSUBSCRIBE_ALL_TOPIC: '/guest/unsubscribeAllTopics',

    GET_USER_INFO: '/user/getUserInfo',
    CREATE_FIREBASE_TOKEN: '/user/firebaseToken/createFirebaseToken',

    GET_APP_USER: '/admin/user/getAppUser',

    // guest
    GUEST_DOCUMENT: '/guest/document/documents',

    // user
    REQUESTS: '/request/requests',
    REQUEST_TYPES: '/request/requestTypes',
    DOCUMENTS: '/request/documents',
    COMPANIES: '/company/companies'

}

export const AppURI = {
    INDEX: '/',

    // public
    NOT_FOUND: '/404',
    LOGIN: '/login',
    PUBLIC_DOCUMENT: '/public/document/:documentCode',
    // Duong dan ngan dung cho ma QR. URL cang ngan thi QR cang it o, in ra
    // kho nho van quet duoc. Route dai o tren phai giu lai vinh vien vi cac
    // QR da in truoc day van tro vao no.
    PUBLIC_DOCUMENT_SHORT: '/d/:documentCode',

    // private
    HOME: '/home',
    SUPPORT: '/support',
    SUPPORT_TICKET_DETAILS: '/support-ticket',
    SPEAKING_TOPICS: '/speaking-topics',
    POST: '/post',
    CREATE_POST: '/create-post',
    REQUESTS: '/requests',
    CREATE_REQUEST: '/create-request',
    REQUEST_DETAILS: '/request-details/:requestId',
    UPDATE_REQUEST: '/update-request',
    DOCUMENT_DETAILS: '/document-details/:documentId',
    DOCUMENTS: '/documents',
    CREATE_DOCUMENT: '/create-document',
    UPDATE_DOCUMENT: '/update-document'
};

export const HttpStatus = {
    OK: 200,
    CREATED: 201,
    ACCEPTED: 202,
    NO_CONTENT: 204,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    PAYMENT_REQUIRED: 402,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    METHOD_NOT_ALLOWED: 405,
    REQUEST_TIMEOUT: 408,
    INTERNAL_SERVER_ERROR: 500,
    SERVICE_UNAVAILABLE: 503,
};

export const LocalStorage = {
    LOGIN_INFO: 'login_info',
    USER_INFO: 'user_info',
    FCM_TOKEN: 'fcm_token'
};

export const Authority = {
    SYS_ADMIN: 'SYS_ADMIN',
    AGENT_ADMIN: 'AGENT_ADMIN'
};

export const ResponseType = {
    MESSAGE_SUCCESS: 'SUCCESS',
    MESSAGE_INFO: 'INFO',
    MESSAGE_WARNING: 'WARNING',
    MESSAGE_ERROR: 'ERROR',
    MESSAGE_REDIRECT: 'REDIRECT'
};

export const RequestStatus: {[key: string]: string} = {
    NEW: 'Mới',
    IN_PROCESS: 'Đang thực hiện',
    FINISHED: 'Hoàn thành'
};

export const DocumentStatus: {[key: string]: string} = {
    IN_PROCESS: 'Đang thực hiện',
    FINISHED: 'Hoàn thành'
};

// --- Kich thuoc khoi QR ---
// Tem duoc in o kho 0.71 x 0.59 inch (18 x 15 mm) bang may in tem 300 DPI.
//
// Luu y quan trong: so pixel cua file KHONG quyet dinh kho in - DPI moi
// quyet dinh. File nhieu pixel hon chi lam ban in MIN hon, kho giay van the.
// Vi vay khong thu file xuong 90px; de file lon va in o 300 DPI se net hon.
//
// QR_SIZE la kich thuoc hien thi tren man hinh (CSS px), khong lien quan
// den file tai xuong - file do QR_EXPORT_WIDTH quyet dinh.
export const QR_SIZE = 128;
export const QR_LOGO_SIZE = Math.round(QR_SIZE * 115 / 256);
export const QR_CODE_FONT_SIZE = Math.round(QR_SIZE * 31.2 / 256);
// Khoi = o vuong QR + mot dong ma ben duoi (line-height 1.5, margin da bo).
export const QR_BLOCK_HEIGHT = QR_SIZE + Math.ceil(QR_CODE_FONT_SIZE * 1.5);

// Tem in o kho 0.59 inch (15 mm) bang may in tem 300 DPI.
// Ma QR rut gon co 37 o, nen 185px cho moi o dung 5 pixel may in: canh o
// trung khit dau kim, khong rang cua. In ra 185/300 = 0.62 inch = 15.7 mm.
// Con so nay la CO DINH cho moi may tai: downloadQR() lay mau ve dung muc
// nay bat ke devicePixelRatio, nen kho in khong doi theo may nguoi dung.
export const QR_EXPORT_WIDTH = 185;
export const QR_PRINT_DPI = 300;


Object.freeze(ApiURI);
Object.freeze(AppURI);
Object.freeze(HttpStatus);
Object.freeze(LocalStorage);
Object.freeze(I18nConfig);
Object.freeze(Authority);
Object.freeze(ResponseType);
